import axios, { AxiosResponse } from 'axios'
import { getUserToken } from '../utility/localStorageFunctions'
import {
  SupplierGroupMembershipRequest,
  SupplierVehiclesResponse,
  supplierGroups,
  supplierGroupsAPIResponse,
  supplierIntegrationDetailsResponse,
} from './suppliergroup.types'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/supplierGroups-api/supplierGroups`

const getSupplierGroups = async (): Promise<
  AxiosResponse<supplierGroupsAPIResponse>
> => {
  const token = await getUserToken('supplierGroups')

  const response = await axios({
    method: 'get',
    url: BASE_URL + '?limit=100',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const getSupplierGroupsBySupplier = async (
  supplierGroupID: number,
  supplierID: number,
): Promise<AxiosResponse<supplierIntegrationDetailsResponse>> => {
  const token = await getUserToken('supplierGroups')

  const response = await axios({
    method: 'get',
    url: BASE_URL.concat(`/${supplierGroupID}/suppliers/${supplierID}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}
const getSupplierGroupById = async (
  id: number,
): Promise<AxiosResponse<supplierGroups>> => {
  const token = await getUserToken('supplierGroups')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${id}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const addSupplierToGroup = async (
  supplierGroupId: number,
  data: SupplierGroupMembershipRequest,
): Promise<AxiosResponse> => {
  const token = await getUserToken('supplierGroups')

  const response = await axios({
    method: 'post',
    url: BASE_URL.concat(`/${supplierGroupId}/suppliers`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { data },
  })
  return response
}

const updateSupplierInGroup = async (
  supplierGroupId: number,
  supplierId: number,
  data: Omit<SupplierGroupMembershipRequest, 'supplierId'>,
): Promise<AxiosResponse> => {
  const token = await getUserToken('supplierGroups')

  const response = await axios({
    method: 'patch',
    url: BASE_URL.concat(`/${supplierGroupId}/suppliers/${supplierId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { data },
  })
  return response
}

const removeSupplierFromGroup = async (
  supplierGroupId: number,
  supplierId: number,
): Promise<AxiosResponse> => {
  const token = await getUserToken('supplierGroups')

  const response = await axios({
    method: 'delete',
    url: BASE_URL.concat(`/${supplierGroupId}/suppliers/${supplierId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const retrieveSupplierVehicleOptions = async (
  supplierGroupId: number,
  supplierId: number,
): Promise<AxiosResponse<SupplierVehiclesResponse>> => {
  const token = await getUserToken('supplierGroups')

  const response = await axios({
    method: 'get',
    url: BASE_URL.concat(
      `/${supplierGroupId}/suppliers/${supplierId}/retrieveSupplierVehicleOptions`,
    ),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

export const supplierGroupsAPI = {
  getSupplierGroups,
  getSupplierGroupById,
  getSupplierGroupsBySupplier,
  addSupplierToGroup,
  updateSupplierInGroup,
  removeSupplierFromGroup,
  retrieveSupplierVehicleOptions,
}
